var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8333 10.8333C10.8333 11.2933 10.46 11.6667 10 11.6667C9.54 11.6667 9.16666 11.2933 9.16666 10.8333V7.5C9.16666 7.04001 9.54 6.66667 10 6.66667C10.46 6.66667 10.8333 7.04001 10.8333 7.5V10.8333ZM10 14.1667C9.54 14.1667 9.16666 13.7933 9.16666 13.3333C9.16666 12.8733 9.54 12.5 10 12.5C10.46 12.5 10.8333 12.8733 10.8333 13.3333C10.8333 13.7933 10.46 14.1667 10 14.1667ZM18.8008 13.5858L12.4075 2.98667C11.9083 2.16001 11.0083 1.66667 10 1.66667C8.99166 1.66667 8.09166 2.16001 7.5925 2.98667L1.19916 13.5858C0.725831 14.3717 0.711664 15.3167 1.16166 16.1133C1.64416 16.9692 2.58166 17.5 3.60666 17.5H16.3933C17.4183 17.5 18.3558 16.9692 18.8383 16.1133C19.2883 15.3167 19.2742 14.3717 18.8008 13.5858Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationError);
export default __webpack_public_path__ + "static/media/notificationError.e4e4e52927232786ded9e867c117472b.svg";
export { ForwardRef as ReactComponent };